import { render, staticRenderFns } from "./UcAttachmentsList.yaml?vue&type=template&id=004edd69&component"
import script from "./UcAttachmentsList.yaml?vue&type=script&lang=ts&component"
export * from "./UcAttachmentsList.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports